export enum UpgradeSimulationTypes {
    MonthToMonth = 0,
    YearToYear = 1,
    MonthToYear = 2,
    YearToMonth = 3,
    ChangeBillingDueDate = 4
}

export interface IUpgradeSimulation  {
    UpgradeSimulationType: UpgradeSimulationTypes;
    CurrentPrice: number;
    CurrentDayPrice: number;
    AmountLeftCurrentCycle: number;
    AmountUsedCurrentCycle: number;
    CurrentDueDate: Date;
    CurrentCycleDays: number;
    CurrentCycleStartDate: Date;
    DaysLeftCurrentCycle: number;
    DaysUsedCurrentCycle: number;
    DateTimeNow: Date;
    DecimalPrecision: number;
    NewCycleDays: number;
    NewCycleStartDate: Date;
    NewDueDate: Date;
    NewPrice: number;
    NewDayPrice: number;
    UpgradeInvoice: number;

}

export class UpgradeSimulation  implements IUpgradeSimulation {
    UpgradeSimulationType: UpgradeSimulationTypes;
    CurrentPrice: number;
    CurrentDayPrice: number;
    AmountLeftCurrentCycle: number;
    AmountUsedCurrentCycle: number;
    CurrentDueDate: Date;
    CurrentCycleDays: number;
    CurrentCycleStartDate: Date;
    DaysLeftCurrentCycle: number;
    DaysUsedCurrentCycle: number;
    DateTimeNow: Date;
    DecimalPrecision: number;
    NewCycleDays: number;
    NewCycleStartDate: Date;
    NewDueDate: Date;
    NewPrice: number;
    NewDayPrice: number;
    UpgradeInvoice: number;

}
